module.exports = __webpack_public_path__ + "static/media/success.5111b34e.svg";